import { RouterType } from '@online-webinar/router';
import { CreateAndEditLiveWebinar } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/edit'].update({
        staticData: { title: { webinar: 'Title.EditWebinar' } },
        component: authGuard(CreateAndEditLiveWebinar, { canBroadcast: true })
    });
};
